<template>
  <ims-button
    type="clear"
    :class="`driver-ball driver-ball-${size}`"
    @click="$emit('click', driver)"
  >
    <div
      v-if="driver"
      class="driver-ball-slot"
    >
      <ims-avatar
        :src="driver.getAvatar()"
        :size="size"
      >
        <ims-badge
          v-if="!showCoin"
          color="green"
          size="sm"
          class="text-white top-left"
        >${{ driver.value }}</ims-badge>
        <ims-coin
          v-if="showCoin"
          :value="driver.totalPoints"
          size="sm"
          class="top-right"
        />
      </ims-avatar>
      <label v-html="label"></label>
    </div>
    <!-- For a Non-selected Driver -->
    <div
      v-else
      class="driver-ball-slot"
    >
      <ims-avatar :size="size">
        <ims-icon
          :icon="icon"
          size="xl"
        />
      </ims-avatar>
      <label v-html="label"></label>
    </div>
  </ims-button>
</template>

<script>
import Driver from '../../classes/driver';
export default {
  props: {
    driver: {
      type: Driver,
      default() {
        return null;
      }
    },
    label: {
      type: String,
      default() {
        return '';
      }
    },
    icon: {
      type: String,
      default() {
        return 'add';
      }
    },
    size: {
      type: String,
      default() {
        return 'md';
      }
    },
    showCoin: {
      type: Boolean,
      default() {
        return true;
      }
    }
  }
};
</script>

<style lang="scss">
.driver-ball-slot {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.driver-ball-md {
  overflow: visible !important;
  padding-left: 4px;
  padding-right: 4px;
  label {
    font-size: 0.85rem;

    .select {
      font-size: 0.7rem;
      line-height: 0.8rem;
    }
  }
  .ims-badge.size-sm {
    font-size: 0.7rem;
    height: 1.1rem;
    padding: 0 4px;
  }

  .ims-avatar {
    .ims-icon {
      font-size: 32px;
    }
  }
}
</style>